import React from "react";
import PageHero from "../../components/pagehero/PageHero";
import Company from "../../components/company/Company";
import WhyChooseTysonWorks from "../../components/whychoosetysonworks/WhyChooseTysonWorks";
import Certifications from "../../components/certifications/Certifications";
import CtaBand from "../../components/ctaband/CtaBand";
import ScrollReveal from "../../components/scroll/ScrollReveal";

const About = () => {
  return (
    <React.Fragment>
      <PageHero
        eyebrow="about"
        title="Your trusted AWS partner"
        lede="A hands-on team of certified cloud experts helping startups and growing businesses succeed on AWS since 2022."
      />
      <Company />
      <ScrollReveal>
        <WhyChooseTysonWorks />
      </ScrollReveal>
      <ScrollReveal>
        <Certifications />
      </ScrollReveal>
      <CtaBand />
    </React.Fragment>
  );
};

export default About;
